import api from '../../../../../services/api';
import type { PositionRiskData } from './types';

export async function fetchPositionRisk(uid: string): Promise<PositionRiskData> {
  const response = await api.get<PositionRiskData>(`/datasources/position-risk/${uid}`);
  return response.data;
}
